// src/components/Dashboard/Dashboard.js
import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardNavBar from './DashboardNavBar';
import PurchasedVideos from './PurchasedVideos';
import DashboardFeedback from './DashboardFeedback';
import Recordings from './Recordings';
import SubscriptionManagement from '../subscription/SubscriptionManagement';
import AdminSubscriptionManagement from '../subscription/AdminSubscriptionManagement';

const Dashboard = () => {
  const user = useSelector((state) => state.auth.user);

  const hasRecordingsAccess      = user?.roles?.some((r) => r === 'ADMIN' || r === 'SITE_OWNER');
  const hasAdminSubscriptionAccess = user?.roles?.includes('ADMIN');
  const hasUserSubscriptionAccess  = !!user;

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Sub-navigation */}
      <DashboardNavBar
        hasRecordingsAccess={hasRecordingsAccess}
        hasSubscriptionAccess={hasUserSubscriptionAccess}
        hasAdminSubscriptionAccess={hasAdminSubscriptionAccess}
      />

      {/* Content */}
      <div className="flex-1 w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route index element={<Navigate to="purchased-videos" replace />} />
          <Route path="purchased-videos" element={<PurchasedVideos />} />
          <Route path="feedback"         element={<DashboardFeedback />} />
          {hasUserSubscriptionAccess && (
            <Route path="subscription" element={<SubscriptionManagement />} />
          )}
          {hasAdminSubscriptionAccess && (
            <Route path="admin-subscription" element={<AdminSubscriptionManagement />} />
          )}
          {hasRecordingsAccess && (
            <Route path="recordings" element={<Recordings />} />
          )}
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
